import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}
function fixBrokenUTF8(str) {
  const bytes = Uint8Array.from([...str].map((ch) => ch.charCodeAt(0)));
  return new TextDecoder("utf-8").decode(bytes);
}
/**
 * Safely decode filename from file path, handling URI-encoded characters
 * @param {string} filePath - The file path containing the filename
 * @returns {string} - The decoded filename or fallback
 */
export function getDecodedFileName(filePath) {
  try {
    const fileName = filePath?.split("/").pop() || "";
    return fixBrokenUTF8(fileName);
  } catch (error) {
    // Fallback if decoding fails (e.g., invalid URI encoding)
    console.warn("Failed to decode filename:", filePath, error);
    return filePath?.split("/").pop() || "";
  }
}
